import apiurl from "../../api/apiurl";
import { apirouter, apikey } from "../../api/apirouter";

export const actiontype = {
  GET_SCALE: "GET_SCALE",
  GET_LOCATION: "GET_LOCATION",
  ORDER_PRINT: "ORDER_PRINT",
  GET_MACHINE_METER_MASTER: "GET_MACHINE_METER_MASTER",
};

export const getScale = () => async (dispatch: any) => {
  try {
    const { data } = await apiurl.get(apirouter.scale);

    if (data.status === true) {
      // จัดกลุ่มข้อมูลตาม factory
      const groupedScales = data.weightScale.reduce((acc: any, scale: any) => {
        const { factory } = scale;
        if (!acc[factory]) {
          acc[factory] = [];
        }
        acc[factory].push(scale);
        return acc;
      }, {});

      dispatch({ type: actiontype.GET_SCALE, payload: groupedScales });
    } else {
      console.log("error" + data.message);
    }
  } catch (error: any) {
    console.log(error);
  }
};

export const getAllLocation = () => async (dispatch: any) => {
  try {
    const { data } = await apiurl.get(apirouter.location);
    // console.log(data);

    if (data.status === true) {
      dispatch({ type: actiontype.GET_LOCATION, payload: data.storagelocation });
    } else {
      console.log("error" + data.message);
    }
  } catch (error: any) {
    console.log(error);
  }
};

export const getorderPrint = (order_number: any) => async (dispatch: any) => {
  // console.log("order_number", order_number);
  try {
    const { data } = await apiurl.get(apirouter.orderprint + order_number);

    // console.log("data", data);

    if (data.status === true) {
      dispatch({ type: actiontype.ORDER_PRINT, payload: data.data });
    } else {
      dispatch({ type: actiontype.ORDER_PRINT, payload: null });
      console.log("error" + data.message);
    }
  } catch (error: any) {
    console.log(error);
  }
}

export const getMachineMeterMaster = () => async (dispatch: any) => {
  try {
    const { data } = await apiurl.get(apirouter.machine_meter_master);
    // console.log(data);

    if (data.status === true) {
      dispatch({
        type: actiontype.GET_MACHINE_METER_MASTER,
        payload: data.data,
      });
    } else {
      console.log("error" + data.message);
    }
  } catch (error: any) {
    console.log(error);
  }
}

export default {
  getScale,
  getAllLocation,
  actiontype,
  getorderPrint,
  getMachineMeterMaster,
};
